/* eslint-disable */
export class Conf {
  static idempiereUrl = "https://idempiere.seritec.eu/";

  static windowTitle = "Smart Calendar";

  static buildNo = "2022-05-27_155532"

}
